import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Fab from "@material-ui/core/Fab";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import LinearProgress from "@material-ui/core/LinearProgress";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import AddIcon from "@material-ui/icons/Add";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RefreshIcon from "@material-ui/icons/Refresh";

//actions
import * as dialogActions from "../../redux/actions/dialogactions";
//constants
import * as shotTypes from "../../redux/constants/ShotActionTypes";
//service
import shotService from "../../services/shotService";
import AddShotDialog from "../addShotDialog";
import { array } from "yup";

class ShotTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null,
      selectedMenu: null,
      shots: [],
      scenes: [],
      fetching: true,
      failed: false,
      dialogStatus: false,
      edit: false,
      shot: null,
      scene: "",
      filterstate: "",
      orderBy: "scene",
      order: "asc"
    };

    this.handleSelectRow = this.handleSelectRow.bind(this);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
  }

  componentDidMount() {
    this.getShots();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.confirmDialog === false && prevProps.confirmDialog) {
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shotTypes.SHOT_DELETE:
            console.log("delete shot!");
            //code the side delete shott side-effect here
            try {
              this.setState({
                fetching: true
              });
              await shotService.deleteOneShot(this.state.selectedRow.id, {
                params: {
                  scene: this.state.selectedRow.scene
                }
              });
              this.getShots();
            } catch (err) {
              console.log(err);
            }
            break;
          default:
            break;
        }
      }
    }
  }

  handleSelectRow(selectedRow) {
    if (this.state.selectedRow) {
      selectedRow.id === this.state.selectedRow.id ? this.setState({ selectedRow: null, selectedMenu: null }) : this.setState({ selectedRow });
    } else {
      this.setState({ selectedRow });
    }
  }

  handleMenu(e, selectedRow) {
    this.setState({ selectedMenu: e.currentTarget, selectedRow, open: true });
  }

  handleCloseMenu() {
    this.setState({ selectedMenu: null });
  }

  getShots = async () => {
    try {
      console.log("fetching shots");
      if (!this.state.fetching) this.setState({ fetching: true });
      let data;
      if (this.props.type === "photo") {
        let shots = await shotService.getPhotoShots();
        data = shots.data;
      } else if (this.props.type === "video") {
        let shots = await shotService.getVideoShots();
        data = shots.data;
      }
      let scenes = data.map(i => i.scene).filter((item, i, arr) => arr.indexOf(item) === i);
      this.setState({
        shots: data,
        scenes: scenes,
        fetching: false,
        failed: false
      });
    } catch (error) {
      console.log("get shots failed: ", error);
      this.setState({
        failed: true,
        fetching: false
      });
    }
  };

  deleteShot = async (id, scene, type) => {
    // try {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to delete this shot. Do you really want to proceed this action?",
      shotTypes.SHOT_DELETE
    );
    // let { data } = await shotService.deleteOneShot(id, {
    //   params: {
    //     scene
    //   }
    // });
    //   this.getShots(type);
    // } catch (error) {
    //   console.log("failed to delete shot: ", error)
    // }
  };

  handleCloseDialog = type => {
    console.log(type);
    if (type) {
      let state = this.state;
      state.fetching = true;
      this.setState(state);
      this.getShots();
      this.setState({
        dialogStatus: false,
        edit: false
      });
    } else {
      this.setState({
        dialogStatus: false,
        edit: false
      });
    }
  };

  openDialog = type => {
    this.setState({
      dialogStatus: true,
      edit: false,
      type
    });
  };

  openEditDialog = (shot, scene) => {
    this.setState({
      shot,
      scene,
      dialogStatus: true,
      edit: true,
      type: shot.type
    });
  };
  goToAddShotPage = () => this.props.history.push("/shots/create/");

  handleViewMore = (id, scene) => {
    this.props.history.push("/shots/preview/" + id + "?scene=" + scene);
  };

  handleEdit = (id, scene) => {
    this.props.history.push("/shots/edit/" + id + "?scene=" + scene);
  };

  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };
  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };
  desc = (a, b, orderBy) => {
    if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
      return -1;
    }
    if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
      return 1;
    }
    return 0;
  };
  handleChangeFilter = e => {
    console.log("filter", e.target.value);
    this.setState({
      filterstate: e.target.value
    });
  };
  render() {
    let menuList = [];
    const { shots, filterstate, order, orderBy } = this.state;
    let queryData = this.stableSort(shots, this.getSorting(order, orderBy));
    let photoLists = queryData
      .filter(e => e.scene.toUpperCase().includes(filterstate.toUpperCase()))
      .map((item, index) => {
        let open;
        let selectedRow;
        let menuAnchorEl;
        if (this.state.selectedRow) {
          open = Boolean(this.state.selectedMenu) && this.state.selectedRow.id === item.id ? true : false;
          selectedRow = this.state.selectedRow.id === item.id ? true : false;
          menuAnchorEl = this.state.selectedRow.id === item.id ? this.state.selectedMenu : null;
        } else {
          open = false;
          selectedRow = false;
          menuAnchorEl = null;
        }

        menuList.push(
          <Menu
            key={index}
            id="long-menu"
            anchorEl={menuAnchorEl}
            open={open}
            onClose={this.handleCloseMenu}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
          >
            <MenuItem onClick={() => this.handleViewMore(item.id, item.scene)}>View more</MenuItem>
            <MenuItem onClick={() => this.handleEdit(item.id, item.scene)}>Edit</MenuItem>
            <MenuItem
              onClick={() => {
                this.deleteShot(item.id, item.scene, item.type);
              }}
            >
              Delete
            </MenuItem>
          </Menu>
        );

        return (
          <TableRow key={item.id}>
            <TableCell>{item.scene}</TableCell>
            <TableCell>{item.description}</TableCell>
            <TableCell>{item.location}</TableCell>
            <TableCell>{item.angle}</TableCell>
            <TableCell>{item.framing}</TableCell>
            {this.props.type === "video" ? <TableCell>{item.camera}</TableCell> : null}
            <TableCell>
              <IconButton aria-label="More" aria-owns={open ? "long-menu" : undefined} aria-haspopup="true" onClick={e => this.handleMenu(e, item)}>
                <MoreVertIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    const headRows =
      this.props.type === "video"
        ? [
            { id: "scene", numeric: false, disablePadding: false, label: "Scene" },
            { id: "description", numeric: false, disablePadding: false, label: "Description" },
            { id: "location", numeric: false, disablePadding: false, label: "Location" },
            { id: "angle", numeric: false, disablePadding: false, label: "Angle" },
            { id: "framing", numeric: false, disablePadding: false, label: "Framing" },
            { id: "camera", numeric: false, disablePadding: false, label: "Camera" },
            { id: "", numeric: false, disablePadding: false, label: "Action" }
          ]
        : [
            { id: "scene", numeric: false, disablePadding: false, label: "Scene" },
            { id: "description", numeric: false, disablePadding: false, label: "Description" },
            { id: "location", numeric: false, disablePadding: false, label: "Location" },
            { id: "angle", numeric: false, disablePadding: false, label: "Angle" },
            { id: "framing", numeric: false, disablePadding: false, label: "Framing" },
            { id: "", numeric: false, disablePadding: false, label: "Action" }
          ];
    return (
      <>
        {/* <div
              style={{
                padding: "12px 24px",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <IconButton onClick={this.getShots}>
                <RefreshIcon fontSize="small" color="primary" />
              </IconButton>
            </div> */}
        <Toolbar variant="dense" style={{ padding: "10px 5px 20px" }} disableGutters={true}>
          <Typography variant="body2" color="textSecondary">
            Total Records: <b>{this.state.shots.length}</b>
          </Typography>
          <div style={{ flexGrow: 1 }} />
          {this.props.type === "video" ? (
            <>
              <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
                Filter Scene:
              </Typography>
              <FormControl variant="outlined" style={{ marginRight: 10 }}>
                <Select
                  value={filterstate}
                  onChange={this.handleChangeFilter}
                  displayEmpty={true}
                  input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.scenes.map(i => (
                    <MenuItem value={i} key={i}>
                      {i}
                    </MenuItem>
                  ))}
                  {/* <MenuItem value="Creative Shot">Creative Shot</MenuItem>
                  <MenuItem value="Establishing">Establishing</MenuItem>
                  <MenuItem value="Inside">Inside</MenuItem>
                  <MenuItem value="Interview w/ Dentists">Interview w/ Dentists</MenuItem>
                  <MenuItem value="Intro">Intro</MenuItem>
                  <MenuItem value="Main">Main</MenuItem>
                  <MenuItem value="Outro">Outro</MenuItem>
                  <MenuItem value="Patient Journey">Patient Journey</MenuItem>
                  <MenuItem value="Team Shoot">Team Shoot</MenuItem>
                  <MenuItem value="Very Far">Very Far</MenuItem> */}
                </Select>
              </FormControl>
            </>
          ) : (
            <>
              <Typography variant="body2" style={{ marginRight: 8 }} color="textSecondary">
                Filter Scene:
              </Typography>
              <FormControl variant="outlined" style={{ marginRight: 10 }}>
                <Select
                  value={filterstate}
                  onChange={this.handleChangeFilter}
                  displayEmpty={true}
                  input={<OutlinedInput name="filter" margin="dense" placeholder="Filter" labelWidth={0} />}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {this.state.scenes.map(i => (
                    <MenuItem value={i} key={i}>
                      {i}
                    </MenuItem>
                  ))}
                  {/* <MenuItem value="Dentist and Patient">Dentist and Patient</MenuItem>
                  <MenuItem value="Establishing">Establishing</MenuItem>
                  <MenuItem value="Individual Shots">Individual Shots</MenuItem>
                  <MenuItem value="Operatories Shots">Operatories Shots</MenuItem>
                  <MenuItem value="Products and Technologies">Products and Technologies</MenuItem>
                  <MenuItem value="Reception Shots">Reception Shots</MenuItem>
                  <MenuItem value="Team Picture">Team Picture</MenuItem>
                  <MenuItem value="Waiting Area Shots">Waiting Area Shots</MenuItem> */}
                </Select>
              </FormControl>
            </>
          )}
          <Divider style={{ margin: "0 10px", height: 40, width: 2 }} />
          <div>
            <Tooltip title="Refresh List">
              <IconButton onClick={this.getShots} aria-label="Refresh">
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Add Shot">
              <Fab
                onClick={this.goToAddShotPage}
                size="small"
                color="primary"
                aria-label="Add"
                style={{
                  marginLeft: "5px",
                  boxShadow: "0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)"
                }}
              >
                <AddIcon />
              </Fab>
            </Tooltip>
          </div>
        </Toolbar>
        <Paper>
          {this.state.fetching && (
            <div style={{ textAlign: "center" }}>
              <LinearProgress color="primary" style={{ height: 2 }} />
            </div>
          )}
          {this.state.failed ? (
            <div style={{ padding: "20px 0", textAlign: "center" }}>
              <Typography variant="h3" gutterBottom style={{ color: "rgba(0,0,0,0.5)" }}>
                Something went wrong...
              </Typography>
              <Button variant="outlined" color="primary" onClick={this.getShots}>
                Reload
              </Button>
            </div>
          ) : (
            /* {photoShots} */
            <Table>
              <TableHead>
                <TableRow>
                  {headRows.map((row, key) => (
                    <TableCell
                      key={key}
                      align={row.numeric ? "right" : "left"}
                      padding={row.disablePadding ? "none" : "default"}
                      sortDirection={orderBy === row.id ? order : false}
                      onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                      style={row.id == "" ? null : { cursor: "pointer" }}
                    >
                      {this.state.orderBy === row.id ? (
                        <TableSortLabel active={orderBy === row.id} direction={order}>
                          {row.label}
                        </TableSortLabel>
                      ) : (
                        row.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>{photoLists}</TableBody>
            </Table>
            /* </Paper> */
          )}
        </Paper>
        {menuList}
        <AddShotDialog
          open={this.state.dialogStatus}
          handleClose={this.handleCloseDialog}
          type={this.props.type}
          getShots={this.getShots}
          shot={this.state.shot}
          edit={this.state.edit}
          scene={this.state.scene}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  let { confirm } = state.dialog;
  return {
    confirmDialog: confirm.open,
    confirmAction: confirm.action,
    confirmChoice: confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShotTable);
